module.exports = __webpack_public_path__ + "img/sure-active.944980f9.svg";